const OrganizationConstants = {
    ORGANIZATION_RECIEVE_ROOTS: 'ORGANIZATION_RECIEVE_ROOTS',
    ORGANIZATION_RECIEVE_CHILDREN: 'ORGANIZATION_RECIEVE_CHILDREN',
    ORGANIZATION_BEGIN_EDIT: 'ORGANIZATION_BEGIN_EDIT',
    ORGANIZATION_END_EDIT: 'ORGANIZATION_END_EDIT',
    ORGANIZATION_EDIT: 'ORGANIZATION_EDIT',
    ORGANIZATION_UPDATE_ORGANIZATION: 'ORGANIZATION_UPDATE_ORGANIZATION',
    ORGANIZATION_RECEIVE_ALL_ROLES: 'ORGANIZATION_RECEIVE_ALL_ROLES',
} as const;

export default OrganizationConstants;
